import { render, staticRenderFns } from "./ServicoControleHorasComissao.vue?vue&type=template&id=528b5329&"
import script from "./ServicoControleHorasComissao.vue?vue&type=script&lang=js&"
export * from "./ServicoControleHorasComissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports